export default __webpack_public_path__ + "e58cc6a201e498cca7ca7fff26c2e4bb.png";